/*
 * Module for the Vesting Table edit page
 */
rs.module("content/system/configuration/vestingtables/edit",

    [
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (visibility, eventBanner) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, columnIds, graduatedVestingGroupKey, grid, ajaxUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var detailFormSection = criteria.js(jsSelectors.detailFormSection);
            var vestingDetailKey = criteria.js(jsSelectors.vestingDetailKey);
            var detailUpdateToken = criteria.js(jsSelectors.detailUpdateToken);
            var serviceCreditFromInput = criteria.js(jsSelectors.serviceCreditFromInput);
            var serviceCreditToInput = criteria.js(jsSelectors.serviceCreditToInput);
            var vestedPercentageInput = criteria.js(jsSelectors.vestedPercentageInput);
            var addDetailLink = criteria.js(jsSelectors.addDetailLink);
            var cancelDetailButton = criteria.js(jsSelectors.cancelDetailButton);

            addDetailLink.click(addDetailClicked);
            cancelDetailButton.click(cancelDetailClicked);

            if (grid) {
                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(ajaxUrl.GetVestingTableDetailAsync,
                            { groupKey: graduatedVestingGroupKey, detailKey: rows[0][columnIds.vestingDetailKey] })
                            .done(function (data) {
                                vestingDetailKey.val(data.vestingDetailKey);
                                serviceCreditFromInput.val(data.fromAmount);
                                serviceCreditToInput.val(data.toAmount);
                                vestedPercentageInput.val(data.vestedPercentage);
                                detailUpdateToken.val(data.updateToken);
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });
            }

            // clear errors, current values, and grid selection when the add detail button is clicked
            function addDetailClicked() {
                eventBanner.removeAllMessages();

                visibility.show(detailFormSection);

                [
                    serviceCreditFromInput,
                    serviceCreditToInput,
                    vestedPercentageInput,
                    detailUpdateToken
                ].forEach((input) => input.val('').clearErrors());

                vestingDetailKey.val(-1).clearErrors();

                grid.selectedValues = null;
            }

            // clear errors and reset grid selection to first row
            function cancelDetailClicked() {
                eventBanner.removeAllMessages();

                // Clear errors
                [
                    serviceCreditFromInput,
                    serviceCreditToInput,
                    vestedPercentageInput,
                    detailUpdateToken
                ].forEach((input) => input.clearErrors());

                grid.selectedValues = null;
                grid.selectFirstRow();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);